import { Component } from '@angular/core';
import { CustomerSupportService } from 'src/app/services/customer-support.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: false
})
export class ContactComponent {
     contactName?: string = '';
     email?: string = '';
     phoneNumber?: string = '';
     topic?: string = '';
     message?: string = '';
     contactNameIsDirty = false;
     emailIsDirty = false;
     phoneIsDirty = false;
     topicIsDirty = false;
     messageIsDirty = true;
     messageSentSuccess = false;
     messageSentError = false;
     sendingMessage = false;
     showLoginHelp = false;
     constructor() { }

     hideLoginHelp() {
          this.showLoginHelp = false;
     }

     updateUrl(url: string) {
          url = url.replace(`##docBaseUrl##`, environment.APP_PSP_DOC_BASE_URL);
          return url;
     }


     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
